import { render, staticRenderFns } from "./WageAuth.vue?vue&type=template&id=7909123c&"
import script from "./WageAuth.vue?vue&type=script&lang=js&"
export * from "./WageAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports